export interface User {
  firstName: string;
  lastName: string;
  fullName: string;
  userName: string;
  nickname: string;
  email: string;
  id: number;
  authToken?: string;
  pictureUrl: string;
  RoleId: number;
  RoleName: string;
  Roles: any[];
  Permissions: any[];
  DefaultLang: string;
}

export const INVALID_USER: User = {
  id: 0,
  firstName: "INVALID",
  lastName: "INVALID",
  fullName: "INVALID",
  userName: "INVALID",
  nickname: "INVALID",
  email: "INVALID",
  pictureUrl: "",
  RoleId: 0,
  RoleName: "INVALID",
  Roles: [],
  Permissions: [],
  DefaultLang: 'es'
};
